import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');
    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');
    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');
    return summary;
  }

  // --- 新增 Hover 逻辑判断 ---
  get #isHoverEnabled() {
    // 检查是否存在 hover 属性或 data-hover="true"
    return this.hasAttribute('hover') || this.dataset.hover === 'true';
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });

    // --- 新增 Hover 事件监听 ---
    this.addEventListener('mouseenter', this.#handleMouseEnter, { signal });
    this.addEventListener('mouseleave', this.#handleMouseLeave, { signal });

    this.details.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;
        if (!event.target.closest('.details-close')) return;

        event.preventDefault();
        event.stopPropagation();
        this.details.open = false;
      },
      { signal },
    );

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  // --- 新增 Hover 处理方法 ---
  #handleMouseEnter = () => {
    if (!this.#isHoverEnabled) return;
    
    const isMobile = isMobileBreakpoint();
    // 如果该平台被禁用，则不触发 hover
    if ((isMobile && this.#disableOnMobile) || (!isMobile && this.#disableOnDesktop)) return;

    this.details.open = true;
  };

  #handleMouseLeave = () => {
    if (!this.#isHoverEnabled) return;
    this.details.open = false;
  };

  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
  };

  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();
    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  #handleKeyDown(event) {
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();
      this.details.open = false;
      this.summary.focus();
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}